import { Link } from 'react-router-dom';

/**
 * Casa de Candy — required consent checkboxes for any submission flow.
 *
 * Two boxes:
 *   • 18+ confirmation
 *   • Terms / Privacy / NDA acceptance (all-in-one)
 *
 * Renders inline in any form. Parent owns the `ageConfirmed` and
 * `termsAccepted` state and passes setters in.
 */
export function ConsentCheckboxes({
  ageConfirmed,
  setAgeConfirmed,
  termsAccepted,
  setTermsAccepted,
  testIdPrefix = 'consent',
  className = '',
}) {
  return (
    <div className={`space-y-3 ${className}`}>
      <label
        className="flex items-start gap-3 p-3 rounded-xl border border-white/10 bg-[#0B0A12]/60 cursor-pointer hover:border-[#FF4DA6]/40 transition-colors"
        data-testid={`${testIdPrefix}-age-label`}
      >
        <input
          type="checkbox"
          checked={ageConfirmed}
          onChange={(e) => setAgeConfirmed(e.target.checked)}
          className="mt-0.5 w-4 h-4 accent-[#FF4DA6] flex-shrink-0"
          data-testid={`${testIdPrefix}-age-checkbox`}
          required
        />
        <span className="text-sm text-[#A7A3BA] leading-relaxed">
          I confirm that I am <span className="text-[#F4F2FF] font-medium">18 years of age or older</span>.
        </span>
      </label>

      <label
        className="flex items-start gap-3 p-3 rounded-xl border border-white/10 bg-[#0B0A12]/60 cursor-pointer hover:border-[#8B5CFF]/40 transition-colors"
        data-testid={`${testIdPrefix}-terms-label`}
      >
        <input
          type="checkbox"
          checked={termsAccepted}
          onChange={(e) => setTermsAccepted(e.target.checked)}
          className="mt-0.5 w-4 h-4 accent-[#8B5CFF] flex-shrink-0"
          data-testid={`${testIdPrefix}-terms-checkbox`}
          required
        />
        <span className="text-sm text-[#A7A3BA] leading-relaxed">
          I have read and agree to the{' '}
          <Link to="/terms" className="text-[#FFB6D8] underline underline-offset-2 hover:text-[#FF7ABD]">
            Terms of Service
          </Link>
          ,{' '}
          <Link to="/privacy" className="text-[#FFB6D8] underline underline-offset-2 hover:text-[#FF7ABD]">
            Privacy Policy
          </Link>
          , and{' '}
          <Link to="/nda" className="text-[#FFB6D8] underline underline-offset-2 hover:text-[#FF7ABD]">
            Non-Disclosure Agreement
          </Link>
          .
        </span>
      </label>
    </div>
  );
}

export default ConsentCheckboxes;
